import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AppService} from '@irb/app.service';
import {IrbAppEvents} from '@irb/app.events';
import {ScheduledService} from '../scheduled/scheduled.service';
import {ISchedule, IDeleteSchdRebalance, IResponseObject} from '../scheduled/scheduled.model';
import {IAlertDialogData} from "@irb/app.model";

@Component({ standalone: false,
    selector: 'irb-delete-scheduled-dialog',
    templateUrl: './delete-scheduled-dialog.component.html',
    styleUrls: ['./delete-scheduled-dialog.component.scss']
})
export class DeleteScheduledDialogComponent implements OnInit, OnDestroy {

    scheduledRebalances: Array<ISchedule>;
    deleteContinueFunction: Function;
    deletedIds: Array<IDeleteSchdRebalance>;
    updateStatusCount = 0;
    progressTimer: any = null;
    isUiTest = false;

    constructor(public dialogRef: MatDialogRef<DeleteScheduledDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private as: AppService,
                private readonly scheduledService: ScheduledService) {

    }

    ngOnInit(): void {
        if (this.mdd.scheduledRebalances !== undefined) {
            this.scheduledRebalances = this.mdd.scheduledRebalances.selectedIds as Array<ISchedule>;
            this.deletedIds = this.getSelectedSchdRebalancesIds();
        }
        this.deleteContinueFunction = this.mdd.deleteContinueFunction || null;
    }

    close() {
        if (this.dialogRef.close !== undefined)
            this.dialogRef.close();
    }

    deleteSelectedSchdReblances() {
        this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
        this.scheduledService.deleteScheduledRebalanceAsync(this.deletedIds).subscribe((response: IResponseObject) => {
            this.updateStatusCount = 0;
            this.progressTimer && clearTimeout(this.progressTimer);
            if (response.responseUtilityMap)
                this.actionStatusCheckIntervalStart(response.responseUtilityMap.actionStatusId);
            //this.proceedDeleteAfterCompleted(response);
        }, () => {
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.close();
        });
    }

    proceedDeleteAfterCompleted(data: any) {
        if (data.responseStatus === "SUCCESS") {
            if (this.deleteContinueFunction !== undefined) {
                this.deleteContinueFunction(data);
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: 'warn',
                    summary: "",
                    detail: this.deletedIds.length + ' Scheduled Rebalance(s) were deleted.'
                });
            }
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.close();
        } else {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: 'error',
                summary: 'Please refresh Page',
                detail: 'Exception occurred'
            });
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.close();
        }
    }

    getSelectedSchdRebalancesIds() {
        const deletedIds: Array<IDeleteSchdRebalance> = [];
        this.scheduledRebalances.forEach(function (item) {
            let id = {} as IDeleteSchdRebalance;
            id.analysisId = item.analysisId;
            id.versionId = item.versionId;
            deletedIds.push(id);
        });
        return deletedIds;
    }

    actionStatusCheckIntervalStart(statusId: any) {
        this.scheduledService.actionStatusCheck(statusId).subscribe((responseData: any) => {
            const reqStatus = responseData.status.trim().toUpperCase();

            if (reqStatus === 'STARTED' || reqStatus === 'NEW' || reqStatus === 'INPROGRESS') {
                let timeout: any = (this.updateStatusCount > 10) ? 8000 : (this.updateStatusCount > 2) ? 3000 : 1500;
                if (this.isUiTest)
                    timeout = 0;
                this.updateStatusCount++;
                this.progressTimer = setTimeout(() => {
                    this.actionStatusCheckIntervalStart(statusId);
                }, timeout);
            }

            if (reqStatus === 'COMPLETED') {
                responseData.responseStatus = "SUCCESS";
                this.proceedDeleteAfterCompleted(responseData);
                this.progressTimer && clearTimeout(this.progressTimer);
            }

            if (reqStatus === 'FAILED') {
                this.close();
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                this.progressTimer && clearTimeout(this.progressTimer);
                this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                    dType: 'ERROR',
                    dTitle: '',
                    dProceedBtnLabel: '',
                    msg: 'An error occurred processing your request.',
                    onProceed: () => {
                    }
                } as IAlertDialogData);
            }

        }, () => {
            this.close();
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            this.progressTimer && clearTimeout(this.progressTimer);
        });
    }

    ngOnDestroy() {
        this.progressTimer && clearTimeout(this.progressTimer);
    }
}
